import * as React from "react"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from "@podcastsoundboard/ps-lib/ui"

const LinkFreesoundAccountDialog: React.FC<{
  onClose: (linked: boolean) => void
  open: boolean
}> = ({ onClose, open }) => {
  return (
    <Dialog open={open} onClose={() => onClose(false)} fullWidth maxWidth="sm">
      <DialogTitle id="alert-dialog-title">Link Freesound Account</DialogTitle>

      <DialogContent>
        <>
          <Typography className="mb-4">
            To import sounds from Freesound, you must link your Freesound
            account. Create a freesound account at{" "}
            <Link href="https://freesound.org" target="_blank">
              freesound.org
            </Link>
            .
          </Typography>

          <Button
            color="info"
            variant="contained"
            onClick={() => {
              window.open(
                `/api/v1/auth/freesound?state=${encodeURIComponent(
                  window.location.pathname,
                )}`,
                "_blank",
              )
              onClose(false)
            }}
          >
            Link Freesound account
          </Button>
        </>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={() => onClose(false)}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LinkFreesoundAccountDialog
